import { Injectable } from '@angular/core';
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map';

import { environment } from './../../environments/environment';
import { UserSearchModel } from './../models/user/user-search.model';

import { UserModel } from '../models/user/user.model';
import { UserListItemModel } from '../models/user/user-list-item.model';
import { Configurations } from "../core/configurations";
import { DizionarioModel } from './../models/shared/dizionario.model';
import { guid } from "../core/utilities";
import { RefreshSIUTokenRequest, RefreshSIUTokenResponse} from "../models/account/ilogin.model";
import {AuthService} from "./auth.service";
@Injectable()
export class UserService {
  //api base url
  APIUtenti = this.configuration.apiBaseUrlUsers;
  //metodi
  MethodLista= "RicercaUtentiConq";
  MethodUpdate= "ChangeAuthorizationConq";
  MethodChange="ChangeAuthorizationConq";
  RefreshSIUToken= "refreshsiutokenconq";
  constructor(private http: Http, private configuration: Configurations,private authenticationService:AuthService) {

 }

////////////////////////////////////////////////////////
//1- Lista utenti
//2- Update abilitazione utente (visibilità o meno della voce menu RicercaClienti)
//3- Refresh token siu
///////////////////////////////////////////////////////


  //1- lista utenti
  getList(model: UserSearchModel): Observable<Response> {
    let searchParams = model || new UserSearchModel();
    return this.http.post(this.APIUtenti + this.MethodLista ,  searchParams)
    .map((r: any) => {
      return r.json();
    } )
    .catch((r: Response, o) => {
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      return Observable.throw(r);
    });
  }

  //2-update abilitazione utente (visibilità o meno della voce menu RicercaClienti)
  updateAbilitazioneUtente(tokenU: string,autoriz: string, abil: boolean): Observable<Response> {
    let url = this.APIUtenti+ this.MethodChange;
    return this.http.post(url, {token: tokenU,autorizzativa:autoriz,  abilita: abil})
    .map(res => { 
      return res.json();  
    })
      .catch((error: any) => {
        if(error.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(error);
      });

  }


  RefreshSIUTokenRequest(tokenU: string): Observable<RefreshSIUTokenResponse> {
    let model= new RefreshSIUTokenRequest();
    model.tokenUtente=tokenU;
    let utente=this.authenticationService.user;
    model.oldSIUToken=utente.SIUToken;
    model.uVRoloil=utente.chosenUV;
    model.zonaRoloil=utente.chosenZona;
    let url = this.APIUtenti+ this.RefreshSIUToken;
    return this.http.post(url, model)
    .map(res => { 
      return res.json() as RefreshSIUTokenResponse;
      })
      .catch((error: any) => {
        if(error.status === 401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(error);
      }
    );
  }


}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/services/user.service.ts